import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M11 8H20M11 16H20" />
		<Path d="M6.62408 17.5H4.62408C4.62408 15.4333 6.62408 15.95 6.62408 14.4C6.62408 13.625 5.62408 12.975 4.62408 13.75" strokeLinecap="square" />
		<Path d="M5.5 10V5.5L4 6" />
	</SVG>
);
